import { render } from "./ProjectAlertSettings.vue?vue&type=template&id=e572aa9c&scoped=true"
import script from "./ProjectAlertSettings.vue?vue&type=script&lang=js"
export * from "./ProjectAlertSettings.vue?vue&type=script&lang=js"

import "./ProjectAlertSettings.vue?vue&type=style&index=0&id=e572aa9c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e572aa9c"]])

export default __exports__